import React, { useState, useEffect, useRef } from 'react';
import './SearchGrid.scss';
import GridFilterTrigger from './GridFilter/GridFilterTrigger';
import GridFilterMain from './GridFilter/GridFilterMain';
import InnerDesktopSearchGrid from './InnerDesktopSearchGrid';
import InnerMobileSearchGrid from './InnerMobileSearchGrid';
import ClearRefinements from './GridFilter/RefineMentList/ClearRefinements';
import { connect } from 'react-redux';
import { Configure, connectStateResults } from 'react-instantsearch-dom';

import { getProductVariantPresentmentPrice } from '../../../components/shared/query/query';
import { useLazyQuery } from '@apollo/client';

const mapStateToProps = (state) => ({
  currency: state.currency,
});

function makeid(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
function SearchGrid(props) {
  const [getProductVariantsQuery, { data: getProductVariantsData, error: getProductVariantsError }] = useLazyQuery(
    getProductVariantPresentmentPrice,
  );

  const [filterEnabled, setFilterEnabled] = useState(true);

  const [mobileFilterEnabled, setMobileFilterEnabled] = useState(false);

  const [customFilter, setCustomFilter] = useState('');

  const [gridWidth, setGridWidth] = useState(0);

  const [savedProductConversions, setSavedProductConversions] = useState([]);

  const gridRef = useRef();

  function triggerFilter() {
    if (window.innerWidth < 992) {
      setMobileFilterEnabled(!mobileFilterEnabled);
    } else {
      setFilterEnabled(!filterEnabled);
    }
  }

  useEffect(() => {
    if (props.source && props.source.origin && props.source.origin === 'homeCollection') {
      setFilterEnabled(false);
    }
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (filterEnabled) {
        if (window.innerWidth < 992) {
          if (gridWidth == 0) {
            setGridWidth(gridRef.current.clientWidth - 15);
          } else {
            setGridWidth(gridRef.current.clientWidth);
          }
        } else {
          // console.log(" pre popping", gridWidth);
          if (gridWidth == 0) {
            setGridWidth(gridRef.current.clientWidth - 220 - 15);
          } else {
            setGridWidth(gridRef.current.clientWidth - 220);
          }
        }
      } else {
        if (gridWidth == 0) {
          setGridWidth(gridRef.current.clientWidth - 15);
        } else {
          setGridWidth(gridRef.current.clientWidth);
        }
      }
    };
    if (filterEnabled) {
      if (window.innerWidth < 992) {
        if (gridWidth == 0) {
          setGridWidth(gridRef.current.clientWidth - 15);
        } else {
          setGridWidth(gridRef.current.clientWidth);
        }
      } else {
        if (gridWidth == 0) {
          setGridWidth(gridRef.current.clientWidth - 220 - 15);
        } else {
          setGridWidth(gridRef.current.clientWidth - 220);
        }
      }
    } else {
      if (gridWidth == 0) {
        setGridWidth(gridRef.current.clientWidth - 15);
      } else {
        setGridWidth(gridRef.current.clientWidth);
      }
    }

    window.addEventListener('resize', onResize, { passive: true });
    return () => {
      window.removeEventListener('resize', onResize, { passive: true });
    };
  }, [filterEnabled, gridWidth]);

  if (props && props.searchResults && props.searchState) {
    if (!(props.source && props.source.origin && props.source.origin === 'homeCollection')) {
      let currentPage = props.hits.length;
      let sendingRefinementList = '';
      let sendingMultiRange = '';
      let sortState = '';
      if (props.searchState) {
        if (props.searchState.refinementList) {
          sendingRefinementList = JSON.stringify(props.searchState.refinementList);
        }
        if (props.searchState.multiRange) {
          sendingMultiRange = JSON.stringify(props.searchState.multiRange);
        }
        if (props.searchState.sortBy) {
          sortState = props.searchState.sortBy;
        }
      }

      let url = new URL(window.location.href);

      let scrollPosition = url.searchParams.get('scrollPosition');

      let sendingStrng;
      if (scrollPosition) {
        sendingStrng =
          window.location.pathname +
          '?refinement=' +
          sendingRefinementList +
          '&' +
          'currentPage=' +
          currentPage +
          '&' +
          'multiRange=' +
          sendingMultiRange +
          '&' +
          'sortBy=' +
          sortState +
          '&' +
          'scrollPosition=' +
          scrollPosition;
      } else {
        sendingStrng =
          window.location.pathname +
          '?refinement=' +
          sendingRefinementList +
          '&' +
          'currentPage=' +
          currentPage +
          '&' +
          'multiRange=' +
          sendingMultiRange +
          '&' +
          'sortBy=' +
          sortState;
      }

      if (!window.location.href.includes(sendingStrng)) {
        if (sendingStrng && window.history) {
          // history.replaceState({}, '', sendingStrng);
        }
      }
    }
  }

  if (typeof window !== `undefined`) {
    let url = new URL(window.location.href);
    let scrollPosition = url.searchParams.get('scrollPosition');
    if (scrollPosition && document.body.clientHeight > scrollPosition) {
      setTimeout(() => {
        window.scrollTo(0, scrollPosition);
      }, 100);

      let newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('scrollPosition');
      window.history.replaceState({}, null, newUrl);
    }
  }

  useEffect(() => {
    let newProducts = [];
    for (let singleHit of props.hits) {
      let marked = false;
      for (let singleSavedProductConversion of savedProductConversions) {
        if (singleSavedProductConversion.id === singleHit.id) {
          marked = true;
          break;
        }
      }

      if (!marked) {
        newProducts.push(singleHit);
      }

      setSavedProductConversions(savedProductConversions.concat(newProducts));
    }
  }, [props.hits]);

  let alteredHits = [...props.hits];
  for (let singleHit of alteredHits) {
    if (!singleHit.converted) {
      for (let singleSavedProductConversion of savedProductConversions) {
        if (
          singleHit.id === singleSavedProductConversion.id &&
          singleSavedProductConversion.converted &&
          singleSavedProductConversion.converted.id
        ) {
          singleHit.converted = singleSavedProductConversion.converted;
        }
      }
    }
  }

  useEffect(() => {
    let requestingProductIds = [];
    let clonedsavedProductConversions = JSON.parse(JSON.stringify(savedProductConversions));
    let isTriggered = false;
    for (let singleSavedProductConversion of clonedsavedProductConversions) {
      if (!singleSavedProductConversion.converted) {
        isTriggered = true;

        let sendingId = btoa('gid://shopify/ProductVariant/' + singleSavedProductConversion.objectID);

        requestingProductIds.push(sendingId);
        singleSavedProductConversion.converted = 'waiting';
      }
    }
    if (isTriggered) {
      setSavedProductConversions(clonedsavedProductConversions);
    }
    if (requestingProductIds.length > 0) {
      getProductVariantsQuery({
        variables: {
          productVariantIds: requestingProductIds,
          currencyCode: props.currency.currencyCode,
        },
      });
    }
  }, [savedProductConversions]);

  useEffect(() => {
    if (getProductVariantsError) {
      return;
    }
    if (getProductVariantsData) {
      let clonedsavedProductConversions = JSON.parse(JSON.stringify(savedProductConversions));
      for (let singleSavedProductConversion of clonedsavedProductConversions) {
        for (let singleProductVariantsData of getProductVariantsData.nodes) {
          if (singleProductVariantsData) {
            let productId = atob(singleProductVariantsData.id).replace('gid://shopify/ProductVariant/', '');
            if (
              singleSavedProductConversion.objectID === productId &&
              singleSavedProductConversion.converted &&
              singleSavedProductConversion.converted === 'waiting'
            ) {
              singleSavedProductConversion.converted = singleProductVariantsData;
            }
          }
        }
      }
      setSavedProductConversions(clonedsavedProductConversions);
    }
  }, [getProductVariantsData, getProductVariantsError]);

  return (
    <div className="gridMain" ref={gridRef}>
      <Configure filters={customFilter}></Configure>
      {!(props.source && props.source.origin && props.source.origin === 'homeCollection') && (
        <div className="new-gridMain-1">
          <GridFilterTrigger
            source={props.source}
            matchParam={props.source.handle}
            triggerFilter={triggerFilter}
            filterEnabled={filterEnabled}
            setCustomFilter={setCustomFilter}
            customFilter={customFilter}
          ></GridFilterTrigger>
        </div>
      )}

      <div className="desktopSearchGrid">
        <div className="new-side-layout">
          <div className={filterEnabled ? 'new-sidebox-left new-sidebox-open' : 'new-sidebox-left'}>
            {typeof window !== `undefined` && window.innerWidth > 992 && (
              <GridFilterMain
                currency={props.currency}
                mobile={false}
                setCustomFilter={setCustomFilter}
                customFilter={customFilter}
              ></GridFilterMain>
            )}
          </div>
          <div className={filterEnabled ? 'new-sidebox-right close-right-p' : 'new-sidebox-right open-right-p'}>
            <InnerDesktopSearchGrid
              {...props}
              filterEnabled={filterEnabled}
              gridWidth={gridWidth}
            ></InnerDesktopSearchGrid>
          </div>
        </div>
        <div
          className="backToTopMain"
          onClick={(event) => {
            window.scrollTo(0, 0);
          }}
        >
          <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 19V1" stroke="#4F5255" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M1 6L7 1L13 6" stroke="#4F5255" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>

      <div className="mobileSearchGrid">
        <div className={!mobileFilterEnabled ? 'd-none' : ''}>
          <div className="mobileSearchFilterOuter">
            <div
              className="mobileSearchFilterClearFixed"
              onClick={() => {
                setMobileFilterEnabled(false);
              }}
            >
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M26 10L10 26" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10 10L26 26" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            {typeof window !== `undefined` && window.innerWidth <= 992 && (
              <GridFilterMain
                currency={props.currency}
                mobile={true}
                setCustomFilter={setCustomFilter}
                customFilter={customFilter}
              ></GridFilterMain>
            )}

            <div style={{ width: '100%', height: '60px' }}> </div>
            <div className="mobileSearchFilterBottomFixed">
              <div className="buttonGroup">
                <ClearRefinements
                  setCustomFilter={setCustomFilter}
                  customFilter={customFilter}
                  mobile={true}
                ></ClearRefinements>

                <div
                  className="applyButton"
                  onClick={() => {
                    setMobileFilterEnabled(false);
                  }}
                >
                  <p>Anwenden</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <InnerMobileSearchGrid {...props} gridWidth={gridWidth} />
        </div>
      </div>
    </div>
  );
}
export default connect(mapStateToProps)(connectStateResults(SearchGrid));
